var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg20(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "144px",
    height: "144px",
    viewBox: "0 0 144 144",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M83.4252 2.03131L98.1537 101.534Q98.1622 101.591 98.164 101.65Q98.1658 101.708 98.1607 101.767Q98.1556 101.825 98.1438 101.882Q98.1319 101.939 98.1135 101.995Q98.0951 102.05 98.0703 102.103Q98.0455 102.156 98.0147 102.206Q97.9839 102.256 97.9475 102.301Q97.9112 102.347 97.8697 102.388Q97.8282 102.43 97.7822 102.466Q97.7362 102.502 97.6863 102.532Q97.6364 102.563 97.5833 102.587Q97.5302 102.612 97.4746 102.63Q97.419 102.648 97.3617 102.659Q97.3044 102.671 97.2461 102.676Q97.1878 102.68 97.1293 102.678Q97.0709 102.676 97.0131 102.667L1.88436 87.9902Q1.85078 87.985 1.81762 87.9776Q1.78446 87.9701 1.75189 87.9604Q1.71931 87.9507 1.68747 87.9388Q1.65563 87.927 1.62467 87.9129Q1.59371 87.8989 1.56378 87.8828Q1.53384 87.8668 1.50507 87.8487Q1.4763 87.8306 1.44882 87.8106Q1.42134 87.7906 1.39529 87.7688Q1.36923 87.747 1.34472 87.7234Q1.32021 87.6999 1.29735 87.6747Q1.2745 87.6496 1.25341 87.6229Q1.23231 87.5963 1.21308 87.5682Q1.19385 87.5402 1.17656 87.511Q1.15928 87.4817 1.14402 87.4513Q1.12876 87.421 1.1156 87.3897Q1.10245 87.3583 1.09145 87.3262Q1.08045 87.294 1.07166 87.2612Q1.06288 87.2283 1.05634 87.195Q1.0498 87.1617 1.04555 87.1279Q1.0413 87.0942 1.03934 87.0603Q1.03739 87.0264 1.03775 86.9924Q1.0381 86.9584 1.04077 86.9245Q1.04343 86.8906 1.0484 86.857Q1.05336 86.8234 1.06059 86.7902Q1.06783 86.757 1.0773 86.7243Q1.08678 86.6917 1.09845 86.6598Q1.11012 86.6279 1.12393 86.5968Q1.13775 86.5658 1.15364 86.5357Q1.16953 86.5057 1.18743 86.4768Q1.20532 86.4479 1.22514 86.4203Q1.24496 86.3927 1.26661 86.3665Q1.28825 86.3403 1.31163 86.3156L81.7119 1.49036Q81.7359 1.46502 81.7616 1.44141Q81.7874 1.41781 81.8147 1.39606Q81.842 1.37431 81.8708 1.35452Q81.8995 1.33473 81.9296 1.317Q81.9597 1.29927 81.9909 1.28368Q82.0222 1.26809 82.0544 1.25472Q82.0867 1.24135 82.1198 1.23027Q82.1529 1.21918 82.1867 1.21044Q82.2205 1.20169 82.2548 1.19533Q82.2892 1.18896 82.3239 1.18501Q82.3586 1.18106 82.3934 1.17954Q82.4283 1.17802 82.4632 1.17894Q82.4981 1.17986 82.5329 1.18321Q82.5677 1.18657 82.6021 1.19234Q82.6365 1.19811 82.6705 1.20628Q82.7044 1.21444 82.7377 1.22495Q82.771 1.23546 82.8035 1.24828Q82.836 1.26109 82.8675 1.27614Q82.899 1.29119 82.9294 1.3084Q82.9598 1.32561 82.9889 1.3449Q83.018 1.36419 83.0457 1.38547Q83.0733 1.40674 83.0995 1.4299Q83.1256 1.45306 83.1501 1.47798Q83.1745 1.50291 83.1972 1.52948Q83.2198 1.55605 83.2406 1.58414Q83.2613 1.61223 83.28 1.64169Q83.2988 1.67116 83.3154 1.70187Q83.332 1.73257 83.3465 1.76436Q83.3609 1.79615 83.3731 1.82887Q83.3853 1.86159 83.3952 1.89508Q83.405 1.92857 83.4126 1.96267Q83.4201 1.99677 83.4252 2.03131L83.4252 2.03131Z",
    transform: "matrix(-0.70710677 -0.70710677 0.70710677 -0.70710677 70.16061 142.92987)",
    id: "path_1"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "mask_1"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path_1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-8",
    transform: "matrix(1 -1.7484555E-07 1.7484555E-07 1 0.5 0.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M83.4252 2.03131L98.1537 101.534Q98.1622 101.591 98.164 101.65Q98.1658 101.708 98.1607 101.767Q98.1556 101.825 98.1438 101.882Q98.1319 101.939 98.1135 101.995Q98.0951 102.05 98.0703 102.103Q98.0455 102.156 98.0147 102.206Q97.9839 102.256 97.9475 102.301Q97.9112 102.347 97.8697 102.388Q97.8282 102.43 97.7822 102.466Q97.7362 102.502 97.6863 102.532Q97.6364 102.563 97.5833 102.587Q97.5302 102.612 97.4746 102.63Q97.419 102.648 97.3617 102.659Q97.3044 102.671 97.2461 102.676Q97.1878 102.68 97.1293 102.678Q97.0709 102.676 97.0131 102.667L1.88436 87.9902Q1.85078 87.985 1.81762 87.9776Q1.78446 87.9701 1.75189 87.9604Q1.71931 87.9507 1.68747 87.9388Q1.65563 87.927 1.62467 87.9129Q1.59371 87.8989 1.56378 87.8828Q1.53384 87.8668 1.50507 87.8487Q1.4763 87.8306 1.44882 87.8106Q1.42134 87.7906 1.39529 87.7688Q1.36923 87.747 1.34472 87.7234Q1.32021 87.6999 1.29735 87.6747Q1.2745 87.6496 1.25341 87.6229Q1.23231 87.5963 1.21308 87.5682Q1.19385 87.5402 1.17656 87.511Q1.15928 87.4817 1.14402 87.4513Q1.12876 87.421 1.1156 87.3897Q1.10245 87.3583 1.09145 87.3262Q1.08045 87.294 1.07166 87.2612Q1.06288 87.2283 1.05634 87.195Q1.0498 87.1617 1.04555 87.1279Q1.0413 87.0942 1.03934 87.0603Q1.03739 87.0264 1.03775 86.9924Q1.0381 86.9584 1.04077 86.9245Q1.04343 86.8906 1.0484 86.857Q1.05336 86.8234 1.06059 86.7902Q1.06783 86.757 1.0773 86.7243Q1.08678 86.6917 1.09845 86.6598Q1.11012 86.6279 1.12393 86.5968Q1.13775 86.5658 1.15364 86.5357Q1.16953 86.5057 1.18743 86.4768Q1.20532 86.4479 1.22514 86.4203Q1.24496 86.3927 1.26661 86.3665Q1.28825 86.3403 1.31163 86.3156L81.7119 1.49036Q81.7359 1.46502 81.7616 1.44141Q81.7874 1.41781 81.8147 1.39606Q81.842 1.37431 81.8708 1.35452Q81.8995 1.33473 81.9296 1.317Q81.9597 1.29927 81.9909 1.28368Q82.0222 1.26809 82.0544 1.25472Q82.0867 1.24135 82.1198 1.23027Q82.1529 1.21918 82.1867 1.21044Q82.2205 1.20169 82.2548 1.19533Q82.2892 1.18896 82.3239 1.18501Q82.3586 1.18106 82.3934 1.17954Q82.4283 1.17802 82.4632 1.17894Q82.4981 1.17986 82.5329 1.18321Q82.5677 1.18657 82.6021 1.19234Q82.6365 1.19811 82.6705 1.20628Q82.7044 1.21444 82.7377 1.22495Q82.771 1.23546 82.8035 1.24828Q82.836 1.26109 82.8675 1.27614Q82.899 1.29119 82.9294 1.3084Q82.9598 1.32561 82.9889 1.3449Q83.018 1.36419 83.0457 1.38547Q83.0733 1.40674 83.0995 1.4299Q83.1256 1.45306 83.1501 1.47798Q83.1745 1.50291 83.1972 1.52948Q83.2198 1.55605 83.2406 1.58414Q83.2613 1.61223 83.28 1.64169Q83.2988 1.67116 83.3154 1.70187Q83.332 1.73257 83.3465 1.76436Q83.3609 1.79615 83.3731 1.82887Q83.3853 1.86159 83.3952 1.89508Q83.405 1.92857 83.4126 1.96267Q83.4201 1.99677 83.4252 2.03131L83.4252 2.03131Z",
    transform: "matrix(-0.70710677 -0.70710677 0.70710677 -0.70710677 70.16061 142.92987)",
    id: "Rectangle",
    fill: "none",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#mask_1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-34",
    transform: "matrix(0.81915206 -0.57357645 0.57357645 0.81915206 -43.820873 51.925236)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0L2.26015 0L2.26015 132.302L0 132.302L0 0Z",
    transform: "translate(0.11984386 1.321045)",
    id: "Rectangle",
    fill: "#0FD8F7",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0L2.26015 0L2.26015 132.302L0 132.302L0 0Z",
    transform: "translate(11.915136 1.589041)",
    id: "Rectangle",
    fill: "#0FD8F7",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0L2.26015 0L2.26015 132.302L0 132.302L0 0Z",
    transform: "translate(21.560898 1.1581749)",
    id: "Rectangle-Copy-3",
    fill: "#0FD8F7",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0L2.26015 0L2.26015 132.302L0 132.302L0 0Z",
    transform: "translate(33.35619 1.4261707)",
    id: "Rectangle-Copy-4",
    fill: "#0FD8F7",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0L2.26015 0L2.26015 132.302L0 132.302L0 0Z",
    transform: "translate(45.15148 1.6941667)",
    id: "Rectangle-Copy-5",
    fill: "#0FD8F7",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0L2.26015 0L2.26015 132.302L0 132.302L0 0Z",
    transform: "translate(54.797245 1.2633005)",
    id: "Rectangle-Copy-6",
    fill: "#0FD8F7",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0L2.26015 0L2.26015 132.302L0 132.302L0 0Z",
    transform: "translate(66.59254 1.5312965)",
    id: "Rectangle-Copy-7",
    fill: "#0FD8F7",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0L2.26015 0L2.26015 132.302L0 132.302L0 0Z",
    transform: "translate(77.81134 0.07526406)",
    id: "Rectangle-Copy-8",
    fill: "#0FD8F7",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0L2.26015 0L2.26015 132.302L0 132.302L0 0Z",
    transform: "translate(88.9593 2.0170164)",
    id: "Rectangle-Copy-9",
    fill: "#0FD8F7",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0L2.26015 0L2.26015 132.302L0 132.302L0 0Z",
    transform: "translate(99.82888 1.6364222)",
    id: "Rectangle-Copy-10",
    fill: "#0FD8F7",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0L2.26015 0L2.26015 132.302L0 132.302L0 0Z",
    transform: "translate(111.04768 0.18038975)",
    id: "Rectangle-Copy-11",
    fill: "#0FD8F7",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0L2.26015 0L2.26015 132.302L0 132.302L0 0Z",
    transform: "translate(121.269936 1.4735519)",
    id: "Rectangle-Copy-12",
    fill: "#0FD8F7",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0L2.26015 0L2.26015 132.302L0 132.302L0 0Z",
    transform: "translate(133.41444 0.66610974)",
    id: "Rectangle-Copy-13",
    fill: "#0FD8F7",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0L2.26015 0L2.26015 132.302L0 132.302L0 0Z",
    transform: "translate(143.78575 1.6601127)",
    id: "Rectangle-Copy-14",
    fill: "#0FD8F7",
    fillRule: "evenodd",
    stroke: "none"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg20);
export default __webpack_public_path__ + "static/media/20.a277d330a16e126c40e89bde8320b434.svg";
export { ForwardRef as ReactComponent };